// extracted by mini-css-extract-plugin
export default {"row":"ImageLabel_row__WP96N","image_container":"ImageLabel_image_container__sryjG","image":"ImageLabel_image__oFfdy"};